export default __webpack_public_path__ + "static/media/59.c0d6f7a9.png";